import BaseTabSchema from 'root-packages/tabSchemaValidation/baseTabSchema.js'

export default class PassengersDetailsDayTourSchema extends BaseTabSchema {
  constructor (options) {
    super(options)
  }

  buildSchema () {
    return {
      passengers: [
        {
          title: this.title(),
          gender: this.passengersSchemaFunctions.present(),
          dateOfBirth: this.config.features.ageRestriction
            ? this.withinAgeRestrictions()
            : this.passengerDateOfBirth(),
          firstName: this.name(),
          middleName: this.nameOptional(),
          lastName: this.name(),
          type: this.type(),
        },
      ],

      leadPassenger: {
        emailAddress: this.email(),
        phoneNumber: this.config.phoneNumberAsString ? this.phoneNumberAsString() : {
          internationalCode: this.phoneNumberCountryCode(),
          number: this.phoneNumber(),
        },
        address: {
          line1: this.requiredAddressLine('street address 1', 2, 40),
          line2: this.addressLine('street address 2', 2, 30),
          city: this.requiredAddressLine('city', 2, 30),
          region: this.region(this.config.localisedWords.region.toLowerCase()),
          country: this.config.ignoreCountry ? undefined : this.passengersSchemaFunctions.present(),
          postcode: this.postcode('ZIP/Postal code'),
        },
      },
    }
  }
}
